import { INVALID_PASSWORD_CONFIRM } from "@/constants/invalids";
import { validator } from "@/utils/validator";

export const resetPasswordSchema = validator.object().shape({
  externalId: validator.string().trim().emptyToNull().label("組織ID").required(),
  newPassword: validator.string().trim().emptyToNull().autoTransformToHalfWidth().strongPassword().label("新しいパスワード").required(),
  confirmNewPassword: validator
    .string()
    .trim()
    .autoTransformToHalfWidth()
    .oneOf([validator.ref("newPassword")], INVALID_PASSWORD_CONFIRM)
    .label("新しいパスワード（確認用）")
    .required(),
});
